/* unplugin-vue-components disabled */import __unplugin_components_1 from '~icons/mdi/share-variant';
import __unplugin_components_0 from '~icons/mdi/close';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.align },
    [
      _c(
        "v-speed-dial",
        {
          staticClass: "v-social",
          attrs: {
            top: _vm.top,
            bottom: _vm.bottom,
            right: _vm.right,
            left: _vm.left,
            direction: _vm.direction,
            "open-on-hover": _vm.hover,
            transition: _vm.transition,
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function () {
                return [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        title: "Compartilhar",
                        fab: "",
                        color: _vm.color,
                        dark: "",
                        icon: "",
                        small: _vm.small,
                      },
                      model: {
                        value: _vm.fab,
                        callback: function ($$v) {
                          _vm.fab = $$v
                        },
                        expression: "fab",
                      },
                    },
                    [_vm.fab ? _c(__unplugin_components_0) : _c(__unplugin_components_1)],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.fab,
            callback: function ($$v) {
              _vm.fab = $$v
            },
            expression: "fab",
          },
        },
        [
          _vm._v(" "),
          _vm.twitter
            ? _c("social-twitter", {
                attrs: { title: _vm.title, url: _vm.url },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.facebook
            ? _c("social-facebook", { attrs: { url: _vm.url } })
            : _vm._e(),
          _vm._v(" "),
          _vm.whatsapp
            ? _c("social-whatsapp", {
                attrs: { title: _vm.title, url: _vm.url },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.telegram
            ? _c("social-telegram", {
                attrs: { title: _vm.title, url: _vm.url },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pinterest
            ? _c("social-pinterest", { attrs: { url: _vm.url } })
            : _vm._e(),
          _vm._v(" "),
          _vm.reddit
            ? _c("social-reddit", { attrs: { title: _vm.title, url: _vm.url } })
            : _vm._e(),
          _vm._v(" "),
          _vm.linkedin
            ? _c("social-linkedin", { attrs: { url: _vm.url } })
            : _vm._e(),
          _vm._v(" "),
          _vm.email
            ? _c("social-email", { attrs: { title: _vm.title, url: _vm.url } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }